import { useQuery } from "react-query";
import { getMGAList } from "../../../../../actions/Utilities/MGA";

export const useGetMGA = () => {
  const { data, isFetching } = useQuery("GetMGAList", getMGAList, {
    refetchOnWindowFocus: false,
  });
  return { data, isFetching };
};
